import React, { FunctionComponent } from "react";
import { Loader as Icon } from 'react-feather';
import { styled } from 'baseui';

//@ts-ignore
const Spin = styled<{ size: number }>('div', ({ size }) => ({
    display: 'inline-block',
    width: `${size}px`,
    height: `${size}px`,
    animationDuration: '3s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
    animationName: {
        from: {
            transform: 'rotate(0deg)',
        },
        to: {
            transform: 'rotate(360deg)',
        },
    },
}));

interface SpinnerIconProps {
    size?: number
}

export const SpinnerIcon:FunctionComponent<SpinnerIconProps> = ({ size = 40 }) => {
    return (
        <Spin size={size}>
            <Icon size={size}/>
        </Spin>
    )
};
